import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppService } from '../app.service';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../shared/libs/auth/auth.service';

@Injectable({
	providedIn: 'root'
})
export class ExcelService {
	readonly #appService = inject(AppService);
	readonly #httpClient = inject(HttpClient);
	readonly authService = inject(AuthService);
	private baseUrl: string = this.#appService.utilsUrls.apiUrl;

	constructor() {}

	public getShootingList(orderId: number): Observable<Blob> {
		const url = this.baseUrl + '/Common/GetShootingList';

		const token = this.authService.getTokenValue;

		return this.#httpClient.get(url, {
			params: { orderId: orderId.toString() },
			responseType: 'blob',
			headers: {
				Authorization: `Bearer ${token}`
			}
		});
	}

	public getImageList(modelId: number): Observable<Blob> {
		const url = this.baseUrl + '/Common/GetShootingList';

		const token = this.authService.getTokenValue;

		return this.#httpClient.get(url, {
			params: { modelId: modelId.toString() },
			responseType: 'blob',
			headers: {
				Authorization: `Bearer ${token}`
			}
		});
	}
}
